/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledLocalVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: rotateY(180deg);
`;

export interface LocalVideoProps extends React.HTMLAttributes<HTMLVideoElement> {
    mediaStream: MediaStream;
}

const LocalVideo: React.FC<LocalVideoProps> = ({ mediaStream, ...props }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    const setVideoSrcObject = () => {
        if (videoRef.current) {
            videoRef.current.srcObject = mediaStream;
            videoRef.current.muted = true;
            videoRef.current.volume = 0;
        }
    };
    useEffect(() => {
        setVideoSrcObject();
    }, []);

    return (
        <StyledLocalVideo
            {...props}
            ref={videoRef}
            autoPlay
            controls={false}
            onContextMenu={(event) => event.preventDefault()}
        />
    );
};

export default LocalVideo;
